import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken() // 让每个请求携带自定义token
  }
  return config
}, error => {
  console.log(error) // for debug
  return Promise.reject(error)
})

// response拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 业务码非200时，按错误处理
    if (res.code !== 200) {
      // 构造一个Error对象，并附加response属性，模拟Axios错误结构
      const error = new Error(res.message || '请求失败')
      error.response = {
        status: res.code,          // 将业务码作为状态码，便于组件识别
        data: res,                 // 完整响应体
        originalResponse: response // 保留原始响应（可选）
      }

      // 提示错误消息
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })

      // 401:未登录
      if (res.code === 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload() // 重新实例化vue-router对象避免bug
          })
        })
      }

      return Promise.reject(error)
    } else {
      // 业务码200，直接返回数据
      return response.data
    }
  },
  error => {
    // HTTP错误（网络错误、超时、HTTP状态码非2xx等）
    console.log('err' + error) // for debug
    Message({
      message: error.message || '网络错误',
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js